'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_schedule$package$ScheduledMealId$() {
  this.NJ = 0;
  this.NK = 0;
  $n_Lmealorama_schedule$package$ScheduledMealId$ = this;
  $m_Lmealorama_schedule$package$ScheduledMealId$();
  this.NJ = 0;
  this.NK = 0;
}
export { $c_Lmealorama_schedule$package$ScheduledMealId$ as $c_Lmealorama_schedule$package$ScheduledMealId$ };
$p = $c_Lmealorama_schedule$package$ScheduledMealId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_schedule$package$ScheduledMealId$;
/** @constructor */
function $h_Lmealorama_schedule$package$ScheduledMealId$() {
}
export { $h_Lmealorama_schedule$package$ScheduledMealId$ as $h_Lmealorama_schedule$package$ScheduledMealId$ };
$h_Lmealorama_schedule$package$ScheduledMealId$.prototype = $p;
var $d_Lmealorama_schedule$package$ScheduledMealId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_schedule$package$ScheduledMealId$, "mealorama.schedule$package$ScheduledMealId$", ({
  LS: 1
}));
export { $d_Lmealorama_schedule$package$ScheduledMealId$ as $d_Lmealorama_schedule$package$ScheduledMealId$ };
var $n_Lmealorama_schedule$package$ScheduledMealId$;
function $m_Lmealorama_schedule$package$ScheduledMealId$() {
  if ((!$n_Lmealorama_schedule$package$ScheduledMealId$)) {
    $n_Lmealorama_schedule$package$ScheduledMealId$ = new $c_Lmealorama_schedule$package$ScheduledMealId$();
  }
  return $n_Lmealorama_schedule$package$ScheduledMealId$;
}
export { $m_Lmealorama_schedule$package$ScheduledMealId$ as $m_Lmealorama_schedule$package$ScheduledMealId$ };
//# sourceMappingURL=mealorama.schedule$package$-Scheduled-Meal-Id$.js.map
